import AppText from './app_text';
const Header = AppText.withComponent('h1');
Header.defaultProps = {
    size: 'xlarge',
    bold: true,
    headingFontFamily: true,
};
export default Header;
//# sourceMappingURL=header.js.map